export const PERMISSION_GROUPS = {
    "Famílias": [
        "FamiliaController",
        "FamiliaReportController",
        "EnderecoController",
        "LogradouroController",
        "LocalidadeController"
    ],

    "Usuários & Perfis": [
        "UsuarioController",
        "UserController",
        "UsuarioReportController",
        "RoleController",
        "TecnicoController",
        "AdminTecnicoController",
        "AdminUnidadeController",
        "StatusController"
    ],

    "Acolhimento": [
        "AcolhimentoController",
        "AcolhimentoCriancaController",
        "AcolhimentoGeralController",
        "RelatorioAcolhimentoController",
        "RelatorioAcolhimentoCriancaController",
        "RelatorioAcolhimentoIdosoController",
        "AcolhimentoSolicitacaoController"
    ],

    "SCFV": [
        "ScfvController",
        "ScfvVinculoController",
        "SituacaoPrioritariaController",
        "RelatorioScfvController"
    ],

    "PAF": [
        "PafController",
        "PAFController",
        "AvaliacaoController",
        "RelatorioPafController"
    ],

    "Atividades": [
        "AtividadeController",
        "AtividadeVinculoController",
        "RelatorioAtividadeController"
    ],

    "Encaminhamentos": [
        "EncaminhamentoController",
        "RelatorioEncaminhamentoController",
        "RelatorioReferenciamentoController"
    ],

    "Atendimento": [
        "AtendimentoController",
        "RelatorioAtendimentoController"
    ],

    "Proteção Especial": [
        "DenunciaController",
        "MedidasController",
        "ViolenciaViolacaoDireitoController",
        "RelatorioDenunciaController",
        "RelatorioMedidaController",
        "RelatorioViolenciaViolacaoDireitoController"
    ],

    "Benefícios & Programas": [
        "BeneficioController",
        "BeneficioFamiliaController",
        "ProgramaSocialController",
        "ProgramaSocialFamiliaController",
        "RelatorioBeneficioController",
        "RelatorioBeneficioConcessoesController",
        "RelatorioProgramaSocialController"
    ],

    "Unidades & Território": [
        "UnidadeController",
        "TipoUnidadeController",
        "RelatorioUnidadeController"
    ],

    "Agenda & Comunicação": [
        "AgendaController",
        "ChatController",
        "NotificationController",
        "ComentarioController",
        "ImprimirUsuarioController",
        "MotivoController"
    ],

    "Documentos & Mídia": [
        "OficioController",
        "MidiaController",
        "GerenciadorArquivoController",
        "RelatorioOficioController"
    ],

    "Relatórios & Painéis": [
        "RelatorioController",
        "RelatorioGestorController",
        "RelatorioTecnicoController",
        "DashboardController",
        "PainelGestorController",
        "AdminAnalyticsController",
        "RelatorioAcessoController"
    ],

    "Administração": [
        "ConfiguracaoController",
        "SettingController",
        "TipoController",
        "ReferenciaController",
        "ImportacaoController",
        "AuditoriaController",
        "TermosUsoController",
        "BotPressController",
        "MapaController",
        "AdminMidiaController"
    ],

    "Suporte & Demandas": [
        "SuporteController",
        "DemandaController"
    ]
};
